export const ThresholdType = {
    Free: "free",
    Custom: "custom"
};

export const ThresholdNotification = {
    Mail: "mail",
    None: "none"
};